import React from 'react';

function WarmthChart() {
  return (
    <div className="warmthcard">
      <div className="top">
        <span className="t">Relationship warmth over time</span>
        <span className="lg">Without Nurturer</span>
      </div>
      <svg viewBox="0 0 460 300" role="img" aria-label="A line declining from warm to cold as a relationship is left without follow-up">
        <defs>
          <linearGradient id="warmth-fade" x1="0" y1="0" x2="0" y2="1">
            <stop offset="0" stopColor="#DD9F3C" stopOpacity="0.30" />
            <stop offset="1" stopColor="#9AA29B" stopOpacity="0.02" />
          </linearGradient>
          <linearGradient id="warmth-line" x1="0" y1="0" x2="1" y2="0">
            <stop offset="0" stopColor="#DD9F3C" />
            <stop offset="0.55" stopColor="#C79B6A" />
            <stop offset="1" stopColor="#9AA29B" />
          </linearGradient>
        </defs>
        <g stroke="rgba(28,40,33,0.08)" strokeWidth="1">
          <line x1="40" y1="40" x2="440" y2="40" />
          <line x1="40" y1="110" x2="440" y2="110" />
          <line x1="40" y1="180" x2="440" y2="180" />
          <line x1="40" y1="250" x2="440" y2="250" />
        </g>
        <path
          d="M40 58 C 130 66, 150 150, 240 178 C 320 202, 360 236, 440 246 L 440 250 L 40 250 Z"
          fill="url(#warmth-fade)"
        />
        <path
          d="M40 58 C 130 66, 150 150, 240 178 C 320 202, 360 236, 440 246"
          fill="none"
          stroke="url(#warmth-line)"
          strokeWidth="3.5"
          strokeLinecap="round"
        />
        <circle cx="40" cy="58" r="6" fill="#DD9F3C" />
        <circle cx="240" cy="178" r="5" fill="#C79B6A" />
        <circle cx="440" cy="246" r="6" fill="#9AA29B" />
        <text x="40" y="34" fontFamily="JetBrains Mono, monospace" fontSize="11" fill="#B6791A" textAnchor="start">
          First call
        </text>
        <text x="240" y="160" fontFamily="JetBrains Mono, monospace" fontSize="11" fill="#8A7E6A" textAnchor="middle">
          Weeks pass
        </text>
        <text x="440" y="232" fontFamily="JetBrains Mono, monospace" fontSize="11" fill="#6C766F" textAnchor="end">
          Gone cold
        </text>
        <text x="46" y="278" fontFamily="JetBrains Mono, monospace" fontSize="10" fill="#9AA29B" textAnchor="start" letterSpacing="0.5">
          DAY 1
        </text>
        <text x="240" y="278" fontFamily="JetBrains Mono, monospace" fontSize="10" fill="#9AA29B" textAnchor="middle" letterSpacing="0.5">
          MONTH 1
        </text>
        <text x="434" y="278" fontFamily="JetBrains Mono, monospace" fontSize="10" fill="#9AA29B" textAnchor="end" letterSpacing="0.5">
          MONTH 3
        </text>
      </svg>
    </div>
  );
}

export default WarmthChart;
